/*eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
import BootstrapTable from 'react-bootstrap-table-next'
import PropTypes from 'prop-types'
import React from 'react'
import paginationFactory from 'react-bootstrap-table2-paginator'
import {filter, forEach, some} from 'lodash'
import { useState, useEffect } from 'react'
import gql from 'graphql-tag'
import { useLazyQuery } from '@apollo/react-hooks'
import {sizeFormatter} from '../utils/fileSizeFunctions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const GET_S3OBJECTS_QUERY = gql`
  query getS3DownloadUrl($input: SaveFileInputs) {
      getS3DownloadUrl(input: $input) {
      downloadUri
      }
  }
`
export default function GroupFileListTable({s3FileLists, itemId, show, setDisableDownload, setValidDownloadUrls}) {

  const [selectedRows, setSelectedRows] = useState([])
  const files =forEach(filter(s3FileLists, function(f) { return (f.location==='s3' || f.movedToS3) && !f.published && f.cuid}), (value, index) =>{
    value.index = index
  })
  useEffect(()=>{
    setDisableDownload(selectedRows.length===0)
  },[selectedRows,setDisableDownload])

  const [getDownloadLinks, {loading, data}] = useLazyQuery(
    GET_S3OBJECTS_QUERY,
    {
      variables: {
        input: {
          selectedRows: selectedRows.map(({cuid}) => {
            return {cuid}})
        }
      },
      fetchPolicy:'no-cache'
    })

  useEffect(()=>{
    if(!show){
      getDownloadLinks()
    }

  },[show,getDownloadLinks])

  const handleOnSelect = (row, isSelect) =>{
    if (isSelect) {
      setSelectedRows([...selectedRows, row])
    } else {
      setSelectedRows(selectedRows.filter(x => x.cuid !== row.cuid))
    }
  }

  const handleOnSelectAll = (isSelect, rows) =>{
    if (isSelect ) {
      setSelectedRows([...selectedRows, ...rows])
    } else {
      setSelectedRows(selectedRows.filter(x => !some(rows, x)))
    }
  }
  const getFileList = () => {
    if(loading) return <span ><FontAwesomeIcon icon={faSpinner} pulse/> &nbsp;Loading data</span>
    if(data) {
      setValidDownloadUrls(data.getS3DownloadUrl)
      return data.getS3DownloadUrl.map((row, index) => {
        return  <><div key={index} style={{wordWrap:'break-word'}}><a href={row.downloadUri} target="_blank" rel="noopener noreferrer">{row.downloadUri}</a></div><br/></>
      })

    }
    return 'error'
  }

  const columns = [
    { dataField: 'name', text: 'File Name',
      headerStyle: (column, colIndex) => { return { width:'85%', textAlign:'center'} },
      sort: true,
      formatter: (cell, row) => {
        let length = itemId.length
        if(row.key)
          cell= row.key.substring(length+1)
        return (
          <div className="text-collapse">
            {cell}
          </div>
        )
      } },
    { dataField: 'size', text: 'File Size', formatter: sizeFormatter,
      headerStyle: (column, colIndex) => { return { width:'10%', textAlign:'center'} },
      sort: false
    }
  ]

  const selectRowProp = {
    mode: 'checkbox',
    clickToSelect: true,
    nonSelectableStyle: { backgroundColor: 'gray' },
    selected: selectedRows.map(row => row.cuid),
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  }

  const paginationOpts = {
    page: 1,
    sizePerPage: 10,
    nextPageText: '>',
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: '20', value: 20
    }, {
      text: 'All', value: files.length
    }]
  }

  return (
    <div className="sb-table-listing">
      {show?<BootstrapTable
        responsive
        wrapperClasses="table-responsive"
        keyField='cuid'
        data={files || []}
        columns={columns}
        bordered={false}
        selectRow={selectRowProp}
        pagination={paginationFactory(paginationOpts)}
        noDataIndication="No Files Available"
        pr
      />:getFileList()}
    </div>
  )
}

GroupFileListTable.propTypes = {
  id: PropTypes.string,
  s3FileLists: PropTypes.array,
  parentId: PropTypes.string,
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  }),
  itemId: PropTypes.string,
  show: PropTypes.any,
  setDisableDownload: PropTypes.any,
  setValidDownloadUrls: PropTypes.any
}

